import { PagePaths, paths } from '@constants/paths';

const inLifePaths = {
  energyTariff: `/${PagePaths.Energy}`,
  energyDetails: `/${PagePaths.Energy}/${PagePaths.EnergyDetails}`,
  orderConfirm: paths.confirm,
  thankYou: paths.thankYou,
} as const;

export { inLifePaths };
